﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';

import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../../plugins/filepond-plugin-file-encode';
import FilePondPluginFileValidateType from '../../../plugins/filepond-plugin-file-validate-type';

import tpl_officeWord from './tpl/officeWord.html';

import View_DialogWaiting2 from '../../../../lib/views/dialogWaiting2/dialogWaiting2';
import View_DialogWaiting from '../../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../../lib/entities/empty';


import config from '../../../../common/config';

export default Marionette.ItemView.extend({
    dialogRegion: '#officeWord_modal',
    errors: [],
    getTemplate: function () {
        return tpl_officeWord({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        //this.listenTo(this.model, 'change', this.render, this);
    },
    ui: {
        'officeWord_input_File_Name': '#officeWord_input_File_Name',
        'officeWord_filePond': '#officeWord_filePond',
        'module_input_ModuleMargin_Top': '#module_input_ModuleMargin_Top',
        'module_input_ModuleMargin_Bottom': '#module_input_ModuleMargin_Bottom',
        'module_input_ModuleMargin_Left': '#module_input_ModuleMargin_Left',
        'module_input_ModuleMargin_Right': '#module_input_ModuleMargin_Right'
    },
    events: {
        'click #officeWord_btn01': 'onBtn01',
        'click #officeWord_btn02': 'onBtn02'
    },
    onRender: function () {
    },
    getFileType: function (mimeType) {
        var ret = 'docx';

        switch (mimeType) {
            case 'application/msword': ret = 'doc'; break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ret = 'docx'; break;
        }

        return ret;
    },
    base64MimeType: function (encoded) {
        var result = null;

        if (typeof encoded !== 'string') {
            return result;
        }

        var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

        if (mime && mime.length) {
            result = mime[1];
        }

        return result;
    },
    onAttach() {
        var self = this;

        FilePond.registerPlugin(
            FilePondPluginFileValidateType,
            FilePondPluginFileEncode,
        );

        var labelIdle = resources.X101435 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.officeWord_filePond[0], {
            labelIdle: [
                labelIdle
            ],
            acceptedFileTypes: [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-word.template.macroEnabled.12',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
                'application/msword'
            ],
            allowMultiple: false,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    var dialogWaitingModel = new Entities_Empty.Model();
                    dialogWaitingModel.attributes.Title = resources.X100322;
                    dialogWaitingModel.attributes.Text = resources.X100301;
                    dialogWaitingModel.attributes.Button = resources.X100279;

                    var dialogWaiting = new View_DialogWaiting2({ model: dialogWaitingModel, parent: self });
                    var callback = function (options) {
                        this.stopListening(dialogWaiting, "dialog:okclicked", callback);
                    }
                    this.listenTo(dialogWaiting, "dialog:okclicked", callback);
                    app.dialogRegion2.show(dialogWaiting);


                    //console.log(err, fileItem.getMetadata('resize'));
                    var base64 = fileItem.getFileEncodeDataURL();
                    var mimeType = self.base64MimeType(base64);
                    var fileData = base64.split(',')[1];
                    //var base64 = fileItem.getFileEncodeBase64String();

                    var tmpModel = new self.collection.model();
                    tmpModel.attributes.AuthUserId = config.authUserId();
                    tmpModel.attributes.FileData = fileData;
                    tmpModel.attributes.FileMimeType = mimeType;
                    tmpModel.attributes.FileUpdate = true;

                    var filename = 'officeWord' + '_' + + new Date().getTime() + '.' + self.getFileType(mimeType);
                    tmpModel.attributes.Filename = filename; //fileItem.filename;
                    tmpModel.attributes.Name = fileItem.filename;
                    tmpModel.attributes.EventId = self.options.parent.options.templateModel.attributes.EventId;
                    tmpModel.attributes.TemplateId = self.options.parent.options.templateModel.attributes.id;
                    tmpModel.attributes.ModuleRegion = self.options.parent.model.attributes.ModuleRegion;
                    tmpModel.attributes.ModuleDiv = self.options.parent.model.attributes.ModuleDiv;
                    tmpModel.attributes.ModuleType = self.options.parent.model.attributes.ModuleType;

                    self.collection.create(tmpModel, {
                        wait: true,
                        success: function (response) {
                            self.model.attributes.id = response.attributes.id;
                            self.model.attributes.InfoFile_id = response.attributes.id;
                            self.model.attributes.InfoFile_FileUrl = response.attributes.FileUrl;
                            self.model.attributes.InfoFile_Name = response.attributes.Name;

                            //dialogWaiting.triggerMethod('dialog:close');

                            //self.collection.fullCollection.sort();
                            //self.collection.getFirstPage({ fetch: false });
                            pond.removeFile(fileItem);

                            self.ui.officeWord_input_File_Name.val(self.model.attributes.InfoFile_Name);
                            //self.model.trigger('change');
                            dialogWaiting.triggerMethod('dialog:close');
                        }
                    });
                }
            }
        });
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        this.model.set({
            ModuleMargin_Top: this.ui.module_input_ModuleMargin_Top.val(),
            ModuleMargin_Bottom: this.ui.module_input_ModuleMargin_Bottom.val(),
            ModuleMargin_Left: this.ui.module_input_ModuleMargin_Left.val(),
            ModuleMargin_Right: this.ui.module_input_ModuleMargin_Right.val()
        });
    }
});